module.exports = __webpack_public_path__ + "static/media/client6.8460f1ab.svg";